import { RouteConfig } from 'src/routing/types'

const ROUTE: RouteConfig = {
  name: 'about',
  path: () => '/about',
}

export default ROUTE
